import { UserPlus } from "lucide-react";
import { Handle, Position, type Node, type NodeProps } from "@xyflow/react";
import type { CreateLeadNodeData } from "./types";

export function CreateLeadNode({ data: _data }: NodeProps<Node<CreateLeadNodeData>>) {
  return (
    <div className="bg-white rounded-xl border-2 border-emerald-300 shadow-md w-[280px] relative pb-10">
      <Handle
        type="target"
        position={Position.Left}
        className="!bg-emerald-400 !w-3 !h-3 !border-2 !border-white"
        style={{ top: "22px", left: 0 }}
      />
      <div className="flex items-center gap-2 px-4 py-3 bg-emerald-50 rounded-t-xl border-b border-emerald-200">
        <UserPlus className="h-4 w-4 text-emerald-500" />
        <span className="font-semibold text-sm text-emerald-700">Create Lead</span>
      </div>
      <div className="absolute bottom-2 right-0 flex items-center">
        <span className="py-0.5 pr-2 rounded-md text-xs font-semibold text-emerald-600 bg-white/80">
          Then
        </span>
        <Handle
          type="source"
          position={Position.Right}
          className="!bg-emerald-400 !w-3 !h-3 !border-2 !border-white"
        />
      </div>
    </div>
  );
}
